'use strict';

angular.module('internal.users')
    .controller('InternalUser', ['$scope', '$stateParams', 'Users', '$rootScope', '$http', function ($scope, $stateParams, Users, $rootScope, $http) {
        $scope.masterUser = $stateParams.user;
        $scope.user = $stateParams.user;
        $scope.userID = $stateParams.id;
        $scope.userLoading = true;

        $scope.setMasterUser = function (user) {
            $scope.masterUser = user;
            $scope.user = angular.copy($scope.masterUser);
        }

        $scope.resetUser = function () {
            if ($scope.masterUser == null) {
                $scope.masterUser = {};
            }
            $scope.user = angular.copy($scope.masterUser);
        }

        $scope.getUser = function () {
            Users.getByID($stateParams.id).then(function (user) {
                $scope.userLoading = false;
                $scope.setMasterUser(user);
            })
        }

        $scope.syncUser = function () {
            $http({
                method: 'POST',
                url: $rootScope.internalURL + 'license/controller.cfm?method=cnt_users.bulkPushUsersByIDs&triggered=true&userIDs=' + $scope.userID
            })
            .then(function (response) {
                $scope.syncInitiated = true;
            })
            .catch(function (response) {
                // handle error
            });
        }

        if ($stateParams.id != null) {
            $scope.getUser();
        }
        else {
            var user = {};
            user.complaints = [];
            user.alerts = [];
            $scope.userLoading = false;
            $scope.setMasterUser(user);
        }
    }])
;